import { get } from "../common/remote/base_api";

export const GetRequestTaken = (data) => {
  return get(`caller/get-taken-requests/`,data);
};
